// extracted by mini-css-extract-plugin
export default {"root":"VVTFa5iszg_QExpIQ0RD","wrap":"bhLHX5TiA_xxGl0b7zaf"};